/* eslint-disable */

export const protobufPackage = "api.common";

/** 發票聯式 */
export enum InvoiceUniform {
  INVOICE_UNIFORM_UNKNOWN = 0,
  /** INVOICE_UNIFORM_DUPLICATE - 二聯式 */
  INVOICE_UNIFORM_DUPLICATE = 1,
  /** INVOICE_UNIFORM_TRIPLICATE - 三聯式 */
  INVOICE_UNIFORM_TRIPLICATE = 2,
}

export function invoiceUniformFromJSON(object: any): InvoiceUniform {
  switch (object) {
    case 0:
    case "INVOICE_UNIFORM_UNKNOWN":
      return InvoiceUniform.INVOICE_UNIFORM_UNKNOWN;
    case 1:
    case "INVOICE_UNIFORM_DUPLICATE":
      return InvoiceUniform.INVOICE_UNIFORM_DUPLICATE;
    case 2:
    case "INVOICE_UNIFORM_TRIPLICATE":
      return InvoiceUniform.INVOICE_UNIFORM_TRIPLICATE;
    default:
      throw new tsProtoGlobalThis.Error("Unrecognized enum value " + object + " for enum InvoiceUniform");
  }
}

export function invoiceUniformToJSON(object: InvoiceUniform): string {
  switch (object) {
    case InvoiceUniform.INVOICE_UNIFORM_UNKNOWN:
      return "INVOICE_UNIFORM_UNKNOWN";
    case InvoiceUniform.INVOICE_UNIFORM_DUPLICATE:
      return "INVOICE_UNIFORM_DUPLICATE";
    case InvoiceUniform.INVOICE_UNIFORM_TRIPLICATE:
      return "INVOICE_UNIFORM_TRIPLICATE";
    default:
      throw new tsProtoGlobalThis.Error("Unrecognized enum value " + object + " for enum InvoiceUniform");
  }
}

/** same as ERP app. refer to: erp/api/common/common.proto:8 */
export interface App {
}

/** 來源 */
export enum App_Source {
  SOURCE_UNKNOWN = 0,
  SOURCE_LATIV = 1,
}

export function app_SourceFromJSON(object: any): App_Source {
  switch (object) {
    case 0:
    case "SOURCE_UNKNOWN":
      return App_Source.SOURCE_UNKNOWN;
    case 1:
    case "SOURCE_LATIV":
      return App_Source.SOURCE_LATIV;
    default:
      throw new tsProtoGlobalThis.Error("Unrecognized enum value " + object + " for enum App_Source");
  }
}

export function app_SourceToJSON(object: App_Source): string {
  switch (object) {
    case App_Source.SOURCE_UNKNOWN:
      return "SOURCE_UNKNOWN";
    case App_Source.SOURCE_LATIV:
      return "SOURCE_LATIV";
    default:
      throw new tsProtoGlobalThis.Error("Unrecognized enum value " + object + " for enum App_Source");
  }
}

/** 平台 */
export enum App_Platform {
  PLATFORM_UNKNOWN = 0,
  /** PLATFORM_WEB_DESKTOP - 網頁電腦版 */
  PLATFORM_WEB_DESKTOP = 1,
  /** PLATFORM_WEB_MOBILE - 網頁M版 */
  PLATFORM_WEB_MOBILE = 2,
  PLATFORM_ANDROID = 4,
  PLATFORM_IOS = 8,
  /** PLATFORM_APP - ANDROID + IOS */
  PLATFORM_APP = 12,
  /** PLATFORM_MOBILE - 行動版, APP + WEB_MOBILE */
  PLATFORM_MOBILE = 14,
  /** PLATFORM_DESKTOP_MOBILE - WEB_DESKTOP + MOBILE */
  PLATFORM_DESKTOP_MOBILE = 15,
}

export function app_PlatformFromJSON(object: any): App_Platform {
  switch (object) {
    case 0:
    case "PLATFORM_UNKNOWN":
      return App_Platform.PLATFORM_UNKNOWN;
    case 1:
    case "PLATFORM_WEB_DESKTOP":
      return App_Platform.PLATFORM_WEB_DESKTOP;
    case 2:
    case "PLATFORM_WEB_MOBILE":
      return App_Platform.PLATFORM_WEB_MOBILE;
    case 4:
    case "PLATFORM_ANDROID":
      return App_Platform.PLATFORM_ANDROID;
    case 8:
    case "PLATFORM_IOS":
      return App_Platform.PLATFORM_IOS;
    case 12:
    case "PLATFORM_APP":
      return App_Platform.PLATFORM_APP;
    case 14:
    case "PLATFORM_MOBILE":
      return App_Platform.PLATFORM_MOBILE;
    case 15:
    case "PLATFORM_DESKTOP_MOBILE":
      return App_Platform.PLATFORM_DESKTOP_MOBILE;
    default:
      throw new tsProtoGlobalThis.Error("Unrecognized enum value " + object + " for enum App_Platform");
  }
}

export function app_PlatformToJSON(object: App_Platform): string {
  switch (object) {
    case App_Platform.PLATFORM_UNKNOWN:
      return "PLATFORM_UNKNOWN";
    case App_Platform.PLATFORM_WEB_DESKTOP:
      return "PLATFORM_WEB_DESKTOP";
    case App_Platform.PLATFORM_WEB_MOBILE:
      return "PLATFORM_WEB_MOBILE";
    case App_Platform.PLATFORM_ANDROID:
      return "PLATFORM_ANDROID";
    case App_Platform.PLATFORM_IOS:
      return "PLATFORM_IOS";
    case App_Platform.PLATFORM_APP:
      return "PLATFORM_APP";
    case App_Platform.PLATFORM_MOBILE:
      return "PLATFORM_MOBILE";
    case App_Platform.PLATFORM_DESKTOP_MOBILE:
      return "PLATFORM_DESKTOP_MOBILE";
    default:
      throw new tsProtoGlobalThis.Error("Unrecognized enum value " + object + " for enum App_Platform");
  }
}

/** FCM Topic */
export enum App_FcmTopic {
  PROMOTION_ANDROID = 0,
  PROMOTION_ANDROID_TEST = 1,
  PROMOTION_IOS = 2,
  PROMOTION_IOS_TEST = 3,
}

export function app_FcmTopicFromJSON(object: any): App_FcmTopic {
  switch (object) {
    case 0:
    case "PROMOTION_ANDROID":
      return App_FcmTopic.PROMOTION_ANDROID;
    case 1:
    case "PROMOTION_ANDROID_TEST":
      return App_FcmTopic.PROMOTION_ANDROID_TEST;
    case 2:
    case "PROMOTION_IOS":
      return App_FcmTopic.PROMOTION_IOS;
    case 3:
    case "PROMOTION_IOS_TEST":
      return App_FcmTopic.PROMOTION_IOS_TEST;
    default:
      throw new tsProtoGlobalThis.Error("Unrecognized enum value " + object + " for enum App_FcmTopic");
  }
}

export function app_FcmTopicToJSON(object: App_FcmTopic): string {
  switch (object) {
    case App_FcmTopic.PROMOTION_ANDROID:
      return "PROMOTION_ANDROID";
    case App_FcmTopic.PROMOTION_ANDROID_TEST:
      return "PROMOTION_ANDROID_TEST";
    case App_FcmTopic.PROMOTION_IOS:
      return "PROMOTION_IOS";
    case App_FcmTopic.PROMOTION_IOS_TEST:
      return "PROMOTION_IOS_TEST";
    default:
      throw new tsProtoGlobalThis.Error("Unrecognized enum value " + object + " for enum App_FcmTopic");
  }
}

/** 收件人 */
export interface Recipient {
  /**
   * Required. 收件人地址
   * 對應 SalesOrder.PaymentType
   * PAYMENT_TYPE_CREDIT_CARD
   * PAYMENT_TYPE_LINE_PAY
   * PAYMENT_TYPE_CASH_ON_DELIVERY
   * PAYMENT_TYPE_APPLE_PAY
   */
  address?:
    | Address
    | undefined;
  /**
   * Required. 海外收件人地址
   * 對應 SalesOrder.PaymentType.PAYMENT_TYPE_OVERSEA
   */
  overseaAddress?:
    | OverseaAddress
    | undefined;
  /** Required. 收件門市 */
  storeAddress?: StoreAddress | undefined;
}

export enum Recipient_Type {
  TYPE_UNSPECIFIED = 0,
  /** TYPE_TW_DELIVERY - 台灣宅配 */
  TYPE_TW_DELIVERY = 1,
  /** TYPE_OVERSEA - 海外 */
  TYPE_OVERSEA = 2,
  /** TYPE_PICKUP_STORE - 超商取貨 */
  TYPE_PICKUP_STORE = 3,
}

export function recipient_TypeFromJSON(object: any): Recipient_Type {
  switch (object) {
    case 0:
    case "TYPE_UNSPECIFIED":
      return Recipient_Type.TYPE_UNSPECIFIED;
    case 1:
    case "TYPE_TW_DELIVERY":
      return Recipient_Type.TYPE_TW_DELIVERY;
    case 2:
    case "TYPE_OVERSEA":
      return Recipient_Type.TYPE_OVERSEA;
    case 3:
    case "TYPE_PICKUP_STORE":
      return Recipient_Type.TYPE_PICKUP_STORE;
    default:
      throw new tsProtoGlobalThis.Error("Unrecognized enum value " + object + " for enum Recipient_Type");
  }
}

export function recipient_TypeToJSON(object: Recipient_Type): string {
  switch (object) {
    case Recipient_Type.TYPE_UNSPECIFIED:
      return "TYPE_UNSPECIFIED";
    case Recipient_Type.TYPE_TW_DELIVERY:
      return "TYPE_TW_DELIVERY";
    case Recipient_Type.TYPE_OVERSEA:
      return "TYPE_OVERSEA";
    case Recipient_Type.TYPE_PICKUP_STORE:
      return "TYPE_PICKUP_STORE";
    default:
      throw new tsProtoGlobalThis.Error("Unrecognized enum value " + object + " for enum Recipient_Type");
  }
}

/**
 * 收件人地址
 * 常用收件地址 及 訂單詳情
 * is_island = false 呈現 黑貓 icon,
 * is_island = true 呈現 離島 icon
 */
export interface Address {
  /** Required. 收件人姓名 */
  name: string;
  /**
   * Optional. 收件人電話
   * Only required when creating order.
   */
  phone: string;
  /** Required. 縣市 */
  city: string;
  /** Required. 地區 */
  area: string;
  /** Required. 街道門牌 */
  street: string;
  /** Optional. 郵遞區號, will fill out by backend according to city/area if empty */
  postcode: string;
  /** Output only. 離島 */
  isIsland: boolean;
}

/**
 * 海外收件人地址
 * 常用收件地址 及 訂單詳情 呈現 順豐 icon
 */
export interface OverseaAddress {
  /** Required. 海外收件人名字 */
  firstName: string;
  /** Required. 海外收件人姓氏 */
  lastName: string;
  /**
   * Optional. 收件人電話
   * Only required when creating order.
   */
  phone: string;
  /**
   * Optional. 電子郵件
   * Only required for country is 越南.
   */
  email: string;
  /** Required. 國碼 */
  phoneCountryCode: string;
  /** Required. 國家/海外地區 */
  country: string;
  /** Required. 州/省/地區 */
  province: string;
  /** Required. 城市 */
  city: string;
  /** Required. 街道門牌 */
  street: string;
  /**
   * Required. 郵遞區號
   * 香港&澳門不需要, 預設給 000000
   */
  postcode: string;
  /** Required. 國家/海外地區英文名稱 */
  englishCountry: string;
  /** Required. 二字簡碼 */
  shortName: string;
}

/** 收件門市 */
export interface StoreAddress {
  /** Required. 收件人姓名 */
  name: string;
  /**
   * Optional. 收件人電話
   * Only required when creating order.
   */
  phone: string;
  /** Required. 門市類型 */
  type: StoreAddress_Type;
  /** Required. 7-11/全家門市id */
  storeId: string;
  /** Output only. 門市名稱 */
  storeName: string;
  /** Output only. 門市地址 */
  storeAddress: string;
  /** Output only. 是否暫停服務 */
  outOfService: boolean;
}

/** 門市類型 */
export enum StoreAddress_Type {
  TYPE_UNSPECIFIED = 0,
  /**
   * TYPE_SEVEN - 7-11, 常用收件地址 及 訂單詳情 呈現 7-11 icon
   * 對應 SalesOrder.PaymentType.PAYMENT_TYPE_SEVEN_ELEVEN
   */
  TYPE_SEVEN = 1,
  /**
   * TYPE_FAMILY - 全家, 常用收件地址 及 訂單詳情 呈現 全家 icon
   * 對應 SalesOrder.PaymentType.PAYMENT_TYPE_FAMILY_MART
   */
  TYPE_FAMILY = 2,
}

export function storeAddress_TypeFromJSON(object: any): StoreAddress_Type {
  switch (object) {
    case 0:
    case "TYPE_UNSPECIFIED":
      return StoreAddress_Type.TYPE_UNSPECIFIED;
    case 1:
    case "TYPE_SEVEN":
      return StoreAddress_Type.TYPE_SEVEN;
    case 2:
    case "TYPE_FAMILY":
      return StoreAddress_Type.TYPE_FAMILY;
    default:
      throw new tsProtoGlobalThis.Error("Unrecognized enum value " + object + " for enum StoreAddress_Type");
  }
}

export function storeAddress_TypeToJSON(object: StoreAddress_Type): string {
  switch (object) {
    case StoreAddress_Type.TYPE_UNSPECIFIED:
      return "TYPE_UNSPECIFIED";
    case StoreAddress_Type.TYPE_SEVEN:
      return "TYPE_SEVEN";
    case StoreAddress_Type.TYPE_FAMILY:
      return "TYPE_FAMILY";
    default:
      throw new tsProtoGlobalThis.Error("Unrecognized enum value " + object + " for enum StoreAddress_Type");
  }
}

/** 銀行 */
export interface Bank {
  /** 銀行代碼 */
  code: string;
  /** 銀行名稱 */
  name: string;
}

function createBaseApp(): App {
  return {};
}

export const App = {
  fromJSON(_: any): App {
    return {};
  },

  toJSON(_: App): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<App>, I>>(base?: I): App {
    return App.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<App>, I>>(_: I): App {
    const message = createBaseApp();
    return message;
  },
};

function createBaseRecipient(): Recipient {
  return { address: undefined, overseaAddress: undefined, storeAddress: undefined };
}

export const Recipient = {
  fromJSON(object: any): Recipient {
    return {
      address: isSet(object.address) ? Address.fromJSON(object.address) : undefined,
      overseaAddress: isSet(object.overseaAddress) ? OverseaAddress.fromJSON(object.overseaAddress) : undefined,
      storeAddress: isSet(object.storeAddress) ? StoreAddress.fromJSON(object.storeAddress) : undefined,
    };
  },

  toJSON(message: Recipient): unknown {
    const obj: any = {};
    message.address !== undefined && (obj.address = message.address ? Address.toJSON(message.address) : undefined);
    message.overseaAddress !== undefined &&
      (obj.overseaAddress = message.overseaAddress ? OverseaAddress.toJSON(message.overseaAddress) : undefined);
    message.storeAddress !== undefined &&
      (obj.storeAddress = message.storeAddress ? StoreAddress.toJSON(message.storeAddress) : undefined);
    return obj;
  },

  create<I extends Exact<DeepPartial<Recipient>, I>>(base?: I): Recipient {
    return Recipient.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<Recipient>, I>>(object: I): Recipient {
    const message = createBaseRecipient();
    message.address = (object.address !== undefined && object.address !== null)
      ? Address.fromPartial(object.address)
      : undefined;
    message.overseaAddress = (object.overseaAddress !== undefined && object.overseaAddress !== null)
      ? OverseaAddress.fromPartial(object.overseaAddress)
      : undefined;
    message.storeAddress = (object.storeAddress !== undefined && object.storeAddress !== null)
      ? StoreAddress.fromPartial(object.storeAddress)
      : undefined;
    return message;
  },
};

function createBaseAddress(): Address {
  return { name: "", phone: "", city: "", area: "", street: "", postcode: "", isIsland: false };
}

export const Address = {
  fromJSON(object: any): Address {
    return {
      name: isSet(object.name) ? String(object.name) : "",
      phone: isSet(object.phone) ? String(object.phone) : "",
      city: isSet(object.city) ? String(object.city) : "",
      area: isSet(object.area) ? String(object.area) : "",
      street: isSet(object.street) ? String(object.street) : "",
      postcode: isSet(object.postcode) ? String(object.postcode) : "",
      isIsland: isSet(object.isIsland) ? Boolean(object.isIsland) : false,
    };
  },

  toJSON(message: Address): unknown {
    const obj: any = {};
    message.name !== undefined && (obj.name = message.name);
    message.phone !== undefined && (obj.phone = message.phone);
    message.city !== undefined && (obj.city = message.city);
    message.area !== undefined && (obj.area = message.area);
    message.street !== undefined && (obj.street = message.street);
    message.postcode !== undefined && (obj.postcode = message.postcode);
    message.isIsland !== undefined && (obj.isIsland = message.isIsland);
    return obj;
  },

  create<I extends Exact<DeepPartial<Address>, I>>(base?: I): Address {
    return Address.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<Address>, I>>(object: I): Address {
    const message = createBaseAddress();
    message.name = object.name ?? "";
    message.phone = object.phone ?? "";
    message.city = object.city ?? "";
    message.area = object.area ?? "";
    message.street = object.street ?? "";
    message.postcode = object.postcode ?? "";
    message.isIsland = object.isIsland ?? false;
    return message;
  },
};

function createBaseOverseaAddress(): OverseaAddress {
  return {
    firstName: "",
    lastName: "",
    phone: "",
    email: "",
    phoneCountryCode: "",
    country: "",
    province: "",
    city: "",
    street: "",
    postcode: "",
    englishCountry: "",
    shortName: "",
  };
}

export const OverseaAddress = {
  fromJSON(object: any): OverseaAddress {
    return {
      firstName: isSet(object.firstName) ? String(object.firstName) : "",
      lastName: isSet(object.lastName) ? String(object.lastName) : "",
      phone: isSet(object.phone) ? String(object.phone) : "",
      email: isSet(object.email) ? String(object.email) : "",
      phoneCountryCode: isSet(object.phoneCountryCode) ? String(object.phoneCountryCode) : "",
      country: isSet(object.country) ? String(object.country) : "",
      province: isSet(object.province) ? String(object.province) : "",
      city: isSet(object.city) ? String(object.city) : "",
      street: isSet(object.street) ? String(object.street) : "",
      postcode: isSet(object.postcode) ? String(object.postcode) : "",
      englishCountry: isSet(object.englishCountry) ? String(object.englishCountry) : "",
      shortName: isSet(object.shortName) ? String(object.shortName) : "",
    };
  },

  toJSON(message: OverseaAddress): unknown {
    const obj: any = {};
    message.firstName !== undefined && (obj.firstName = message.firstName);
    message.lastName !== undefined && (obj.lastName = message.lastName);
    message.phone !== undefined && (obj.phone = message.phone);
    message.email !== undefined && (obj.email = message.email);
    message.phoneCountryCode !== undefined && (obj.phoneCountryCode = message.phoneCountryCode);
    message.country !== undefined && (obj.country = message.country);
    message.province !== undefined && (obj.province = message.province);
    message.city !== undefined && (obj.city = message.city);
    message.street !== undefined && (obj.street = message.street);
    message.postcode !== undefined && (obj.postcode = message.postcode);
    message.englishCountry !== undefined && (obj.englishCountry = message.englishCountry);
    message.shortName !== undefined && (obj.shortName = message.shortName);
    return obj;
  },

  create<I extends Exact<DeepPartial<OverseaAddress>, I>>(base?: I): OverseaAddress {
    return OverseaAddress.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<OverseaAddress>, I>>(object: I): OverseaAddress {
    const message = createBaseOverseaAddress();
    message.firstName = object.firstName ?? "";
    message.lastName = object.lastName ?? "";
    message.phone = object.phone ?? "";
    message.email = object.email ?? "";
    message.phoneCountryCode = object.phoneCountryCode ?? "";
    message.country = object.country ?? "";
    message.province = object.province ?? "";
    message.city = object.city ?? "";
    message.street = object.street ?? "";
    message.postcode = object.postcode ?? "";
    message.englishCountry = object.englishCountry ?? "";
    message.shortName = object.shortName ?? "";
    return message;
  },
};

function createBaseStoreAddress(): StoreAddress {
  return { name: "", phone: "", type: 0, storeId: "", storeName: "", storeAddress: "", outOfService: false };
}

export const StoreAddress = {
  fromJSON(object: any): StoreAddress {
    return {
      name: isSet(object.name) ? String(object.name) : "",
      phone: isSet(object.phone) ? String(object.phone) : "",
      type: isSet(object.type) ? storeAddress_TypeFromJSON(object.type) : 0,
      storeId: isSet(object.storeId) ? String(object.storeId) : "",
      storeName: isSet(object.storeName) ? String(object.storeName) : "",
      storeAddress: isSet(object.storeAddress) ? String(object.storeAddress) : "",
      outOfService: isSet(object.outOfService) ? Boolean(object.outOfService) : false,
    };
  },

  toJSON(message: StoreAddress): unknown {
    const obj: any = {};
    message.name !== undefined && (obj.name = message.name);
    message.phone !== undefined && (obj.phone = message.phone);
    message.type !== undefined && (obj.type = storeAddress_TypeToJSON(message.type));
    message.storeId !== undefined && (obj.storeId = message.storeId);
    message.storeName !== undefined && (obj.storeName = message.storeName);
    message.storeAddress !== undefined && (obj.storeAddress = message.storeAddress);
    message.outOfService !== undefined && (obj.outOfService = message.outOfService);
    return obj;
  },

  create<I extends Exact<DeepPartial<StoreAddress>, I>>(base?: I): StoreAddress {
    return StoreAddress.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<StoreAddress>, I>>(object: I): StoreAddress {
    const message = createBaseStoreAddress();
    message.name = object.name ?? "";
    message.phone = object.phone ?? "";
    message.type = object.type ?? 0;
    message.storeId = object.storeId ?? "";
    message.storeName = object.storeName ?? "";
    message.storeAddress = object.storeAddress ?? "";
    message.outOfService = object.outOfService ?? false;
    return message;
  },
};

function createBaseBank(): Bank {
  return { code: "", name: "" };
}

export const Bank = {
  fromJSON(object: any): Bank {
    return { code: isSet(object.code) ? String(object.code) : "", name: isSet(object.name) ? String(object.name) : "" };
  },

  toJSON(message: Bank): unknown {
    const obj: any = {};
    message.code !== undefined && (obj.code = message.code);
    message.name !== undefined && (obj.name = message.name);
    return obj;
  },

  create<I extends Exact<DeepPartial<Bank>, I>>(base?: I): Bank {
    return Bank.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<Bank>, I>>(object: I): Bank {
    const message = createBaseBank();
    message.code = object.code ?? "";
    message.name = object.name ?? "";
    return message;
  },
};

declare var self: any | undefined;
declare var window: any | undefined;
declare var global: any | undefined;
var tsProtoGlobalThis: any = (() => {
  if (typeof globalThis !== "undefined") {
    return globalThis;
  }
  if (typeof self !== "undefined") {
    return self;
  }
  if (typeof window !== "undefined") {
    return window;
  }
  if (typeof global !== "undefined") {
    return global;
  }
  throw "Unable to locate global object";
})();

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends Array<infer U> ? Array<DeepPartial<U>> : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
